import { Component, Input, TemplateRef } from "@angular/core";
import { ApplicationSettings } from "../core/coresettings";
import { ChildInfo } from "./nested-list.component";

@Component({
    selector: "crew-searchable-nested-list",
    template: require('./searchable-nested-list.component.html')
})
export class SearchableNestedList {

    constructor() {
        this.showInactive = ApplicationSettings.instance.showInactive;
    }

    @Input()
    searchAsYouType: boolean;

    @Input()
    items: any[];

    @Input()
    getChildrenFuncs: ((item: any) => ChildInfo)[];

    @Input()
    itemDisplayName: string;

    @Input()
    itemDetailsState: string;

    @Input()
    itemTemplate: TemplateRef<any>;

    @Input()
    getIsActive: (item: any) => boolean;

    currentlyTypedSearchText: string;
    activeSearchText: string;
    showInactive: boolean;

    onCurrentlyTypedSearchTextChange(value: string): void {
        if (!this.searchAsYouType) {
            return;
        }

        this.activeSearchText = value;
    }

    onInactiveChange(value: boolean): void {
        ApplicationSettings.instance.showInactive = value;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/shared/searchable-nested-list.component.ts